import { useEffect } from 'react';
import { useNewDesign } from '../../hooks/useNewDesign';

/**
 * Mirrors the `newDesign` feature flag onto <body> as a `new-design` class, so
 * plain CSS (which cannot read Redux) can scope redesign-only rules — currently
 * the Noto Sans family in scss/_custom.scss.
 *
 * Renders nothing; mount it once near the app root.
 */
export const NewDesignBodyClass = (): null => {
  const isNewDesign = useNewDesign();

  useEffect(() => {
    document.body.classList.toggle('new-design', isNewDesign);

    return () => {
      document.body.classList.remove('new-design');
    };
  }, [isNewDesign]);

  return null;
};

export default NewDesignBodyClass;
